export default __webpack_public_path__ + "1b3b1e29053c6e627b2e088c07e8af1d.png";